export default __webpack_public_path__ + "static/media/road.9f7692d4.png";